// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-365","content":"styles_content__1fzOK","tableWrap":"styles_tableWrap__1J_0c"};